export default __webpack_public_path__ + "static/3-e8ad1ad9001c3c173fbb0c172ce6298e.jpeg";